import { render } from "./DiscoverPlaylist.vue?vue&type=template&id=2afa052f&scoped=true"
import script from "./DiscoverPlaylist.vue?vue&type=script&lang=js"
export * from "./DiscoverPlaylist.vue?vue&type=script&lang=js"

import "./DiscoverPlaylist.vue?vue&type=style&index=0&id=2afa052f&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afa052f"]])

export default __exports__